import { useState } from "react";

import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Field, FieldLabel } from "@/components/ui/field";
import { Textarea } from "@/components/ui/textarea";

/** Rad etish sababi shunchaki "yo'q" demaslik uchun — muallif buni o'qiydi. */
export const MIN_REASON_LENGTH = 10;

interface ReasonDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (reason: string) => void;
  isPending?: boolean;
  /** Tarjima qilingan sarlavha va tushuntirish. */
  title: string;
  description: string;
  label: string;
  placeholder: string;
  confirmLabel: string;
}

/**
 * Forma alohida komponentda va faqat oyna OCHIQ bo'lganda chiziladi —
 * shu tufayli maydonni tozalaydigan effekt kerak emas: oyna yopilganda
 * komponent yechiladi va keyingi ochilishda `useState("")` yangi boshlanadi.
 */
const ReasonForm = ({
  onConfirm,
  onCancel,
  isPending,
  label,
  placeholder,
  confirmLabel,
}: Pick<ReasonDialogProps, "onConfirm" | "isPending" | "label" | "placeholder" | "confirmLabel"> & {
  onCancel: () => void;
}) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState("");
  const tooShort = reason.trim().length < MIN_REASON_LENGTH;

  return (
    <>
      <Field>
        <FieldLabel htmlFor="reason-dialog-input">{label}</FieldLabel>
        <Textarea
          id="reason-dialog-input"
          rows={4}
          value={reason}
          onChange={event => setReason(event.target.value)}
          placeholder={placeholder}
        />
        <p className="text-muted-foreground text-xs">
          {t("MODERATION.REJECT_MIN", { min: MIN_REASON_LENGTH })}
        </p>
      </Field>

      <DialogFooter>
        <Button variant="outline" onClick={onCancel} disabled={isPending}>
          {t("COMMON.CANCEL")}
        </Button>
        <Button
          variant="destructive"
          disabled={tooShort || isPending}
          loading={isPending}
          onClick={() => onConfirm(reason.trim())}
        >
          {confirmLabel}
        </Button>
      </DialogFooter>
    </>
  );
};

/**
 * Sabab so'raydigan tasdiqlash oynasi — rad etish uchun umumiy.
 *
 * Kurs moderatsiyasida allaqachon shunday oyna bor edi; blog, sharh va
 * o'qituvchilik arizalari uchun uni uch marta ko'chirish o'rniga bitta
 * komponent qoldi.
 */
export const ReasonDialog = ({
  open,
  onOpenChange,
  onConfirm,
  isPending,
  title,
  description,
  label,
  placeholder,
  confirmLabel,
}: ReasonDialogProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>
      </DialogHeader>

      {open && (
        <ReasonForm
          onConfirm={onConfirm}
          onCancel={() => onOpenChange(false)}
          isPending={isPending}
          label={label}
          placeholder={placeholder}
          confirmLabel={confirmLabel}
        />
      )}
    </DialogContent>
  </Dialog>
);
